import { render } from "./ConversationMessageParent.vue?vue&type=template&id=1e5a3594&scoped=true"
import script from "./ConversationMessageParent.vue?vue&type=script&lang=js"
export * from "./ConversationMessageParent.vue?vue&type=script&lang=js"

import "./ConversationMessageParent.vue?vue&type=style&index=0&id=1e5a3594&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1e5a3594"

export default script